import {
    FETCH_ACTIVE_ORDERS,
    CLOSE_ORDER,
    CANCEL_ORDER,
    RESEND_ORDER,
    TOGGLE_SOUND_NOTIFICATIONS,
} from '../../actions/types';
import { playNotificationSound } from '../../helpers/sounds';

const INITIAL_STATE = {
    ordersUpdateDate: null,
    orders: [],
    muteSoundNotifications: localStorage.getItem('muteSoundNotifications') !== null
        ? JSON.parse(localStorage.getItem('muteSoundNotifications'))
        : true
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TOGGLE_SOUND_NOTIFICATIONS:
            localStorage.setItem('muteSoundNotifications', !state.muteSoundNotifications);
            return { ...state, muteSoundNotifications: !state.muteSoundNotifications };
        case FETCH_ACTIVE_ORDERS:
            if (state.ordersUpdateDate) {
                if (action.payload.length) {
                    const newOrderExists = action.payload.some(order => order.closeDate === null);
                    if (newOrderExists && !state.muteSoundNotifications) playNotificationSound();
                }
            }
            return {
                ...state,
                orders: action.payload,
                ordersUpdateDate: new Date(),
            };
        case CLOSE_ORDER:
            return {
                ...state, orders: state.orders.map(order => {
                    if (order.guid === action.payload.orderGuid) order.closeDate = new Date().toLocaleString();
                    return order;
                })
            };
        case CANCEL_ORDER:
            return { ...state, orders: state.orders.filter(order => order.guid !== action.payload.orderGuid) };
        case RESEND_ORDER:
            return {
                ...state,
                orders: state.orders.map(o => (o.id === action.meta.orderId) ? { ...o, posOrderId: action.payload.OrderId } : o)
            };
        default:
            return state;
    }
};
